import type { Dimensions } from 'Shared/posters/types';

//XXX cf moving more code in here?

export type TextResizeMode = '' | 'textWidth' | 'fieldWidth' | 'textCorner';

// The in-flight text resize gesture. It starts in TextResizeHandles (mousedown on a handle) and commits
// in SelectableObject's document mouseup, so both halves of what the gesture knows travel on this shared
// object: which resize is running, and the linked-template slot it detached (null when it detached
// nothing — every design-mode resize, and any user-mode resize of a leaf already detached or unlinked).
// The slot is set with the mode rather than separately so it can never outlive the gesture that took it.
export class ResizeMode
{
	private theMode: TextResizeMode = '';
	private slot: Dimensions | null = null;

	mode() { return this.theMode; }
	detachedSlot() { return this.slot; }

	begin(mode:TextResizeMode, detachedSlot: Dimensions | null) { this.theMode = mode; this.slot = detachedSlot; }
	end() { this.theMode = ''; this.slot = null; }
}
